import { ElementRef, Injectable, NgZone } from '@angular/core';

import Prism from 'prismjs';
import * as prismManual from './prism-manual-mode';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CodeThemeService {
  public prism$ = of(prismManual);

  constructor(private ngZone: NgZone) {}

  public highlight(codeBlock: ElementRef, code: string, language: string) {
    this.prism$.subscribe({
      complete: () => this.highlightCode(codeBlock, code, language),
    });
  }

  private highlightCode(
    codeBlock: ElementRef,
    code: string,
    language: string
  ): void {
    this.ngZone.runOutsideAngular(() => {
      // Prismjs order of method calls is effectively:
      // highlightAll -> highlightElement -> highlight
      /**
       * Each have their own set of hooks that are called
       * Plugins are attached to these hooks. LineNumbers is attached to the `complete`
       * hook, which only runs in the highlightElement and highlightAll method.
       *
       * highlight is the lowest level method, you should stick with the first two
       * before resorting to highlight.
       * https://prismjs.com/docs/Prism.html
       */
      Prism.highlightElement(codeBlock.nativeElement);
      Prism.highlight(code, Prism.languages[language], language);
    });
  }
}
